import { Link } from 'react-router-dom'
import { ArrowRight, Sparkles, Newspaper, PhoneCall, Mail } from 'lucide-react'
import { Button } from '@/components/ui/button'

export function Press() {
  return (
    <div className="min-h-screen bg-black text-white">
      <section className="relative max-w-5xl mx-auto px-6 py-16">
        <div className="absolute inset-0 bg-gradient-to-b from-[#050309] via-black to-black -z-10" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_0%_0,rgba(212,175,55,0.18),transparent_55%),radial-gradient(circle_at_100%_100%,rgba(74,31,184,0.35),transparent_55%)] -z-10" />

        <div className="flex items-center justify-between gap-4 mb-10">
          <Link to="/" className="text-sm text-gray-400 hover:text-[#D4AF37] transition-colors">
            &larr; Back to home
          </Link>
          <span className="inline-flex items-center gap-2 text-xs md:text-sm text-gray-400">
            <Sparkles className="w-4 h-4 text-[#D4AF37]" />
            For press, partners & festivals
          </span>
        </div>

        <header className="mb-10">
          <p className="inline-flex items-center gap-2 rounded-full border border-[#D4AF37]/40 bg-[#D4AF37]/10 px-3 py-1 text-xs font-medium text-[#FFD700] mb-4">
            <Newspaper className="w-4 h-4" />
            Binyuma TV – background & assets
          </p>
          <h1 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-[#D4AF37] via-[#FFFFFF] to-[#D4AF37] bg-clip-text text-transparent">
            Press & Partnerships
          </h1>
          <p className="text-base md:text-lg text-gray-300 max-w-2xl">
            Binyuma TV is the vertical‑first streaming home for premium African stories. We bring
            Nollywood‑quality dramas and series to the screens and feeds where African audiences actually live.
          </p>
        </header>

        <section className="mb-10 grid md:grid-cols-2 gap-8">
          <div className="p-6 rounded-xl bg-gradient-to-br from-gray-900 to-black border border-gray-800">
            <h2 className="text-xl font-semibold mb-3">Quick facts</h2>
            <ul className="text-sm text-gray-400 space-y-2">
              <li>• Vertical‑first streaming platform focused 100% on African stories and creators.</li>
              <li>• Mobile‑first experience with premium HLS streaming optimised for African networks.</li>
              <li>• Designed as a home for episodic dramas shot for 9:16, not chopped from TV.</li>
            </ul>
          </div>
          <div className="p-6 rounded-xl bg-gradient-to-br from-gray-900 to-black border border-gray-800">
            <h2 className="text-xl font-semibold mb-3">Story angles</h2>
            <ul className="text-sm text-gray-400 space-y-2">
              <li>• “The vertical drama network redefining Nollywood for a phone‑first generation.”</li>
              <li>• “What happens when Nollywood and TikTok have a premium baby.”</li>
              <li>• “Giving African creators a home built for series, not skits.”</li>
            </ul>
          </div>
        </section>

        <section className="mb-10">
          <h2 className="text-xl font-semibold mb-4">Partnerships we're excited about</h2>
          <ul className="text-sm text-gray-400 space-y-2">
            <li>• Data and bundle partnerships with telcos to unlock night and weekend binging.</li>
            <li>• Film schools and labs nurturing the next generation of African showrunners.</li>
            <li>• Festivals and cultural events looking to showcase bold African storytelling in new formats.</li>
          </ul>
        </section>

        <section className="mb-12">
          <h2 className="text-xl font-semibold mb-4">Contact</h2>
          <p className="text-sm text-gray-400 mb-4">
            For press kits, interviews, speaking opportunities, or partnership conversations, reach out to our
            team.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="mailto:press@binyumatv.com"
              className="inline-flex items-center justify-center rounded-md px-4 py-2 text-sm font-medium bg-[#D72638] hover:bg-[#D72638]/90 text-white transition-colors"
            >
              <Mail className="w-4 h-4 mr-2" />
              Email press team
            </a>
            <a
              href="mailto:partners@binyumatv.com"
              className="inline-flex items-center justify-center rounded-md px-4 py-2 text-sm font-medium border border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37]/10 transition-colors"
            >
              <PhoneCall className="w-4 h-4 mr-2" />
              Talk partnerships
            </a>
          </div>
        </section>

        <div className="pt-8 border-t border-gray-900 flex flex-col sm:flex-row gap-4 sm:items-center sm:justify-between">
          <p className="text-xs text-gray-500">
            Want to see Binyuma in action? Download the app and explore our latest originals.
          </p>
          <Link to="/download">
            <Button className="bg-[#D72638] hover:bg-[#D72638]/90 text-white">
              Download Binyuma TV
              <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  )
}
